import './App.css';
import {Provider} from 'react-redux'
import { ThemeProvider } from '@material-ui/core/styles';
import {store,persistor} from './store'
import theme from './theme'
import Routes from './routes';
import Backdrop from 'components/Modal/backdrop';
import Modal from 'components/Modal'
import { PersistGate } from 'redux-persist/integration/react'
import 'react-lazy-load-image-component/src/effects/blur.css';
import "video-react/dist/video-react.css";
function App() {
  return (
   <div>
     <Provider store={store}>
     <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
        <Backdrop/>
          <Modal/>
          <Routes/> 
        </ThemeProvider>
        </PersistGate>
     </Provider>
   </div>
  );
}

export default App;
